import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";
import Skeleton from "@mui/material/Skeleton";
import AddBank from "../BankCard/AddBank";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "80%",
  bgcolor: "#FFFFFF",
  boxShadow: 24,
  outline: "none",
  borderRadius: "16px",
  p: 4,
};

function SelectUserBank({ open, handleClose, onSelectBank }) {
  const [userBanks, setUserBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openAddBank, setOpenAddBank] = useState(false);

  const fetchBanks = () => {
    setLoading(true);
    getServices
      .getUserBanks()
      .then((response) => {
        if (response.data.statusCode === 200) {
          setUserBanks(response.data.data.content);
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.response?.data?.description);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (open) {
      fetchBanks();
    }
  }, [open]);

  return (
    <>
      <AddBank
        open={openAddBank}
        handleClose={() => {
          setOpenAddBank(false);
          fetchBanks();
        }}
      />
      <Modal
        aria-labelledby="select-user-bank-title"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div className="flex justify-between items-center mb-6">
              <h2
                id="select-user-bank-title"
                className="text-[#1A1A1B] text-[18px] font-[700]"
              >
                Select bank account
              </h2>
              <button
                onClick={handleClose}
                className="w-8 h-8 rounded-full bg-[#1C1F2A] flex items-center justify-center text-white hover:bg-[#2C3142] transition-colors focus:outline-none"
              >
                <CloseIcon style={{ fontSize: "16px" }} />
              </button>
            </div>

            <div className="max-h-[300px] overflow-y-auto mb-4 scrollbar-hide">
              {loading ? (
                Array.from(new Array(2)).map((_, idx) => (
                  <div key={idx} className="mb-4">
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </div>
                ))
              ) : userBanks.length > 0 ? (
                userBanks.map((bank, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center py-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={() => {
                      onSelectBank(bank);
                    }}
                  >
                    <div>
                      <p className="text-[#1A1A1B] text-[15px] font-[500] mb-1">
                        {bank.bankName}
                      </p>
                      <p className="text-[#808285] text-[14px]">
                        {bank.accountName}
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-[#1A1A1B] text-[14px] font-[600]">
                        {bank.accountNumber}
                      </span>
                      <ArrowForwardIosIcon
                        style={{ fontSize: "12px", color: "#1A1A1B" }}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500 my-4 text-[14px]">
                  No bank accounts found.
                </p>
              )}
            </div>

            <div className="mt-6">
              <button
                onClick={() => setOpenAddBank(true)}
                className="bg-[#FAFBFC] text-[#00BC67] text-[14px] font-[700] py-2.5 px-5 rounded-md flex items-center gap-2 leading-[150%]"
              >
                New bank{" "}
                <span className="text-[18px] leading-none mb-0.5">+</span>
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default SelectUserBank;
